import { render, staticRenderFns } from "./SingleCenterPartnership.vue?vue&type=template&id=7ea6ea14&"
import script from "./SingleCenterPartnership.vue?vue&type=script&lang=js&"
export * from "./SingleCenterPartnership.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports